import Value from '../ui/Value'

const parseDate = (string) => new Value('', string)

function fetchFieldsFromChange({organization, assignedUntil, ...props}) {
  return {
    ...props,
    availablePeople: organization ? organization.autocompletePeople : [],
    assignedUntil: parseDate(assignedUntil),
  }
}

export default fetchFieldsFromChange
